import styled from 'styled-components';

export const EmptyCatalogContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 1.5rem;
  width: 30rem;
  margin: 1.5rem auto;
`;
